import React, { useState, useEffect, useRef } from "react";
import "./usuarios.css";
import CardFilter from "../CardFilter";
import UsuariosTable from "./UsuariosTable";
import * as api from "helper/helper";
import toast from "react-hot-toast";

import { FaPlus } from "react-icons/fa6";
import CreateUser from "./CreateUser";

export default function UsuariosDashboard({ subSection }) {
  const buttonModalRef = useRef();
  const buttonModalEditRef = useRef();
  const modalRef = useRef();
  const createClienteRef = useRef();
  //const [items, setItems] = useState([]);
  const [modalData, setModalData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [filter, setFilter] = useState("Hoy");
  const handleFilterChange = (filter) => {
    setFilter(filter);
  };

  //--
  const [usuarios, setUsuarios] = useState({});
  //const { username } = useAuthStore((state) => {

  const fetchData = async () => {
    //let loadingvalue = true;
    //const { data, status } = await pagoniUsuarios().catch(() => {
    setIsLoading(true);
    const response = await api.usuarios().catch((e) => {
      toast.error("Error al pedir usuarios.");
      setIsLoading(false);
    });
    if (!response) return;

    setUsuarios(response.data);
    setIsLoading(false);

    console.log(response.status);
  };

  useEffect(() => {
    fetchData();
  }, []);

  function createUser(event) {
    console.log(event);
    setModalData(null);
  }

  function reloadUsuarios() {
    fetchData();
  }

  function loadItem(item) {
    console.log(modalRef);

    /*modalRef.current.style.display += "block";
    modalRef.current.classList.add("show");
    setOpenModal(true);*/
    setModalData(item);

    buttonModalEditRef.current.click();
  }

  return (
    <div className="card recent-sales overflow-auto">
      <CardFilter filterChange={handleFilterChange} />
      <div className="card-body">
        <h5 className="card-title">
          Usuarios <span>|{filter}</span>
          <span>
            <button
              ref={buttonModalRef}
              className="btn btn-primary"
              onClick={createUser}
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
            >
              <div>
                <FaPlus />
                Crear
              </div>
            </button>
            <button
              ref={buttonModalEditRef}
              className="btn btn-primary"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
              hidden
            >
              <div>
                <FaPlus />
                Crear
              </div>
            </button>
          </span>
        </h5>
        <UsuariosTable
          items={usuarios}
          openItem={loadItem}
          isLoading={isLoading}
        />
      </div>

      <div
        ref={modalRef}
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <CreateUser
          ref={createClienteRef}
          item={modalData}
          reloadUsuarios={reloadUsuarios}
        />
      </div>
    </div>
  );
}
